import api from '@/utils/axios';

const LOGIN_URL = '/auth/login';
const LOGOUT_URL = '/auth/logout';

export default {
  login(prefix, data) {
    return api().post(prefix + LOGIN_URL, data);
  },
  logout(prefix) {
    return api().post(prefix + LOGOUT_URL);
    // return true;
  },
};
